/**
 * 从 currentDevice 解析物理设备唯一键（iOS UDID / Android id）。
 * @param {Object} [currentDevice] - localStorage currentDevice 对象
 * @returns {string}
 */
export const resolveCurrentDeviceKey = currentDevice => {
  if (!currentDevice || typeof currentDevice !== 'object') return ''

  return (
    currentDevice['Unique Identifier'] ||
    currentDevice.unique_identifier ||
    currentDevice.id ||
    ''
  )
}
